import { useState } from "react";
import { ChevronRight, ShoppingBag, XCircle } from "lucide-react";
import { Link } from "react-router-dom";

const MeusPedidos = () => {
  const [activeTab, setActiveTab] = useState("todos");

  const statusMessages = {
    todos: {
      title: "Nenhum pedido encontrado",
      description: "Você não possui nenhum pedido registrado",
    },
    processando: {
      title: "Nenhum pedido em processamento",
      description: "Você não possui pedidos sendo processados no momento",
    },
    enviados: {
      title: "Nenhum pedido enviado",
      description: "Você não possui pedidos em transporte no momento",
    },
    entregues: {
      title: "Nenhum pedido entregue",
      description: "Você não possui pedidos finalizados no momento",
    },
    cancelados: {
      title: "Nenhum pedido cancelado",
      description: "Você não possui pedidos cancelados no momento",
    },
  };

  const orders = {
    todos: [],
    processando: [],
    enviados: [],
    entregues: [],
    cancelados: [],
  };

  const tabs = [
    { id: "todos", label: "Todos" },
    { id: "processando", label: "Processando" },
    { id: "enviados", label: "Enviados" },
    { id: "entregues", label: "Entregues" },
    { id: "cancelados", label: "Cancelados" },
  ];

  const getStatusColor = (status) => {
    const colors = {
      processando: "bg-yellow-500",
      enviados: "bg-blue-500",
      entregues: "bg-green-500",
      cancelados: "bg-red-500",
    };
    return colors[status] || "bg-gray-500";
  };

  return (
    <div className="max-w-7xl mx-auto p-1">
      <header className="mb-8">
        <h1 className="text-2xl font-bold">Meus Pedidos</h1>
        <p className="text-gray-600">
          Acompanhe e gerencie todos os seus pedidos
        </p>
      </header>

      <div className="mb-6">
        <div className="flex gap-2 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-lg font-medium ${
                activeTab === tab.id
                  ? "bg-gray-100 text-green-600"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {orders[activeTab].length === 0 ? (
          <div className="text-center py-12">
            <XCircle className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium">
              {statusMessages[activeTab].title}
            </h3>
            <p className="text-gray-600 mt-1">
              {statusMessages[activeTab].description}
            </p>
          </div>
        ) : // não terá conteúdo porque orders[activeTab] está vazio
        null}
      </div>
    </div>
  );
};

export default MeusPedidos;
